export default __webpack_public_path__ + "static/media/userWhite.8bea4c5b.svg";